// File: v4/components/v4/PrimaryInfoV4.tsx

import React from 'react';
import { Control, Controller, FieldErrors, UseFormRegister } from 'react-hook-form';
import Select from 'react-select';
import clsx from 'clsx';
import { PaymentTypes } from '../../types/PaymentTypes';
import { CreateBookingFormV4 } from '../../../../services/create-booking-v4/schema/CreateBookingSchemaV4';
import DateInput from '../../../../shared/components/form/DateInput';

interface PrimaryInfoPropsV4 {
    index: number;
    control: Control<CreateBookingFormV4>;
    register: UseFormRegister<CreateBookingFormV4>;
    errors: FieldErrors<CreateBookingFormV4>;
    isUpdateMode: boolean;
}

const PrimaryInfoV4: React.FC<PrimaryInfoPropsV4> = ({ index, control, register, errors, isUpdateMode }) => {
    // Tentukan apakah ini kamar utama atau kamar tambahan
    const isPrimaryRoom = index === 0;

    return (
        <div className="col-sm-4">
            <div className="col-12 mb-3">
                <label className="col-form-label">Payment Type:</label>
                {isUpdateMode || isPrimaryRoom ? (
                    // Dropdown aktif jika mode update ATAU kamar utama
                    <Controller
                        control={control}
                        name={`bookingroom.${index}.payment_type`}
                        render={({ field }) => (
                            <Select
                                className={clsx({ 'is-invalid': errors.bookingroom?.[index]?.payment_type })}
                                options={PaymentTypes}
                                value={PaymentTypes.find(p => p.value === field.value)}
                                onChange={(opt) => field.onChange(opt?.value)}
                            />
                        )}
                    />
                ) : (
                    // Kamar berikutnya (di mode create) hanya menampilkan label dari kamar pertama
                    <Controller
                        control={control}
                        name="bookingroom.0.payment_type"
                        render={({ field }) => (
                            <p className="form-control bg-light text-muted mb-0">
                                {PaymentTypes.find(p => p.value === field.value)?.label || field.value || 'N/A'}
                            </p>
                        )}
                    />
                )}
                {errors.bookingroom?.[index]?.payment_type && (
                    <div className="invalid-feedback d-block">
                        {errors.bookingroom[index].payment_type.message}
                    </div>
                )}
            </div>

            {/* ==================================================================== */}
            {/* PERBAIKAN UTAMA: Tampilkan input atau teks berdasarkan index         */}
            {/* ==================================================================== */}
            <div className="col-12 mb-3">
                <label className="col-form-label">Check In:</label>
                {isUpdateMode || isPrimaryRoom ? (
                    // Input tanggal aktif jika mode update ATAU kamar utama
                    <DateInput className="form-control" isInvalid={!!errors.bookingroom?.[index]?.checkin_date} {...register(`bookingroom.${index}.checkin_date`)} />
                ) : (
                    // Kamar berikutnya (di mode create) hanya menampilkan nilai dari kamar pertama
                    <Controller control={control} name="bookingroom.0.checkin_date" render={({ field }) => (
                        <p className="form-control bg-light text-muted mb-0">{field.value || 'N/A'}</p>
                    )} />
                )}
                {errors.bookingroom?.[index]?.checkin_date && <div className="invalid-feedback">{errors.bookingroom[index].checkin_date.message}</div>}
            </div>
            <div className="col-12">
                <label className="col-form-label">Check Out:</label>
                {isUpdateMode || isPrimaryRoom ? (
                    // Input tanggal aktif jika mode update ATAU kamar utama
                    <DateInput className="form-control" isInvalid={!!errors.bookingroom?.[index]?.checkout_date} {...register(`bookingroom.${index}.checkout_date`)} />
                ) : (
                    // Kamar berikutnya (di mode create) hanya menampilkan nilai dari kamar pertama
                    <Controller control={control} name="bookingroom.0.checkout_date" render={({ field }) => (
                        <p className="form-control bg-light text-muted mb-0">{field.value || 'N/A'}</p>
                    )} />
                )}
                {errors.bookingroom?.[index]?.checkout_date && <div className="invalid-feedback">{errors.bookingroom[index].checkout_date.message}</div>}
            </div>
        </div>
    );
};

export default PrimaryInfoV4;